export const UPDATE_INSPECTION_ITEMS = 'Update inspection items';
export const DEFECTS_ANALYSIS = 'Defects analysis';
export const GENERATE_REPORTS = 'Generate reports';
export const UPDATE_ELEMENTS = 'Update elements';
export const UPLOAD_ADDITIONAL_FILES = 'Upload additional files';
export const UPLOAD_FOLDER_STRUCTURE = 'Upload folder_structure.csv file';
export const UPLOAD_GLB = 'Upload digital twin glb';
export const UPLOAD_LIDAR_DATA = 'Upload lidar data';
export const UPLOAD_GSP = 'Upload GCP';
export const UPLOAD_IMAGES = 'Upload images';
export const UPLOAD_IMAGES_LINK = 'Upload images link';
export const RELOCATE_IMAGES = 'Relocate images';
export const DOWNLOAD_IMAGES = 'Download images';
export const AI_DETECTION = 'AI Detection';
export const UPDATE_ELEMENTS_REMARKS = 'Update elements remarks';
export const UPLOAD_OSGB = 'Upload OSGB';
export const LOGS = 'Logs';
export const UPLOAD_3D_TILES = "Upload 3D-Tiles";
export const UPLOAD_IMAGES_CSV = 'Upload images csv';
export const CALIBRATE_MODELS = 'Calibrate models';
export const UPDATE_REMARKS = 'Update remarks';
export const ELEMENTS_ALLOCATION = 'Elements allocation';
export const ASSET = 'Asset';
export const SURVEY = 'Survey';
export const BRIDGE_MODELS = 'bridge_models';
export const israeliOrganizationIds = [201, 220];
export const defaultCalibrationData = {
  show: true,
  alpha: 1,
  calibrationData: {    
              lon: 0,
              lat: 0,
              height: 0,
              "rotate-x": 0,
              "rotate-y": 0,
              "rotate-z": 0,
              centerTarget: undefined,
              scale: 1
            }
          }